import { GetTransactionRes, SummaryMipNameTct } from '@dealstack/shared/lib/generated';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';

type PersonMipOpenTsaWarningRes = {
	hasOpenTsa: boolean;
};

export const getAvailableMipsForPerson = async (params: {
	personId: string;
}): Promise<SummaryMipNameTct[]> => {
	return await makeRequest<ApiV1.Response<SummaryMipNameTct[]>>({
		endpoint: `${formatUnicorn(API_PATHS.PERSON_PERSONID_MIP_AVAILABLE_FOR_LINKING_GET, {
			personId: params.personId,
		})}`,
		method: HTTP_METHOD.GET,
	}).then((response) => response.payload ?? []);
};

export const getAvailablePersonTransactionsForMipRequest = async ({
	mipId,
	personId,
	isUnlink,
}: {
	personId: string;
	mipId: string;
	isUnlink?: boolean;
}): Promise<GetTransactionRes[]> => {
	return await makeRequest<ApiV1.Response<GetTransactionRes[]>>({
		endpoint: formatUnicorn(API_PATHS.PERSON_PERSONID_MIP_MIPID_TRANSACTIONS_GET, {
			personId,
			mipId,
		}),
		queryString: {
			isUnlink,
		},
		method: HTTP_METHOD.GET,
	}).then((response) => response.payload ?? []);
};

export const getPersonMipOpenTsaWarningRequest = async ({
	personId,
	mipId,
}: {
	personId: string;
	mipId: string;
}): Promise<PersonMipOpenTsaWarningRes> => {
	return await makeRequest<ApiV1.Response<PersonMipOpenTsaWarningRes>>({
		endpoint: formatUnicorn(API_PATHS.PERSON_PERSONID_MIP_MIPID_OPEN_TSA_WARNING_GET, {
			personId,
			mipId,
		}),
		method: HTTP_METHOD.GET,
	}).then((response) => ({
		hasOpenTsa: response.payload?.hasOpenTsa ?? false,
	}));
};
